module.exports = __webpack_public_path__ + "static/media/ismoyo-logo-text-small.50c84ceb.webp";